import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { TooltipEl } from "common/components/tooltip";
import { RestrictEntitySaving } from "common/report/constants";
import { currentProjectStore } from "common/report/stores/project-details";
import { SelectEl } from "common/components/select";
import { Directions } from "common/components/drop-menu/types";
import { ButtonLayout } from "common/components/button/constants";
export function template() {
  var _a, _b, _c;
  const { cohortDetails } = this.state;
  if (!((_a = currentProjectStore.value) == null ? void 0 : _a.canSaveEntity(RestrictEntitySaving.Cohorts)) && !this.attr(`show-upsell-in-dropdown`)) {
    return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        theme: this.attr(`theme`),
        icon: `share`,
        layout: this.attr(`layout`)
      },
      on: {
        click: this.handleUpsell
      }
    }, this.attr(`label`) && /* @__PURE__ */ jsx("span", {
      sel: ".button-label"
    }, "Upgrade to Create Cohort")), /* @__PURE__ */ jsx(TooltipEl, {
      attrs: { "max-width": `250px` }
    }, "When you upgrade your plan, cohorts can be created and saved to use across all reports in a project."));
  }
  if (this.attr(`disabled`)) {
    return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        theme: this.attr(`theme`),
        disabled: this.attr(`disabled`),
        icon: this.attr(`icon`),
        layout: this.attr(`layout`)
      }
    }, this.attr(`label`)), this.attr(`tooltip`) && /* @__PURE__ */ jsx(TooltipEl, {
      attrs: { "max-width": `250px` }
    }, this.attr(`tooltip`)));
  }
  if (cohortDetails.length === 1 && ((_b = currentProjectStore.value) == null ? void 0 : _b.canSaveEntity(RestrictEntitySaving.Cohorts))) {
    return /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        theme: this.attr(`theme`),
        disabled: this.attr(`disabled`),
        icon: this.attr(`icon`),
        layout: this.attr(`layout`)
      },
      on: {
        click: this.handleClick
      }
    }, this.attr(`label`));
  }
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      icon: {
        leftIcon: this.attr(`icon`)
      },
      "icon-only": !!this.attr(`icon`) && !this.attr(`label`),
      layout: this.attr(`layout`),
      theme: this.attr(`theme`),
      ...this.attr(`layout`) === ButtonLayout.Vertical ? {
        "menu-width": 230
      } : {},
      "menu-alignment": Directions.CenterDown,
      sections: [
        {
          items: this.attr(`show-upsell-in-dropdown`) && !((_c = currentProjectStore.value) == null ? void 0 : _c.canSaveEntity(RestrictEntitySaving.Cohorts)) ? [
            {
              value: `upsell`,
              label: `Upgrade to Create Cohort`,
              icon: `share`
            }
          ] : cohortDetails.map((cohortDetail) => ({
            value: cohortDetail.type,
            label: cohortDetail.label
          }))
        }
      ],
      "selected-option": this.attr(`label`),
      disabled: this.attr(`disabled`)
    },
    on: {
      change: this.handleClick
    }
  }), this.attr(`tooltip`) && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { "max-width": `250px` }
  }, this.attr(`tooltip`)));
}
